import script from "./Stage.vue?vue&type=script&setup=true&lang=js"
export * from "./Stage.vue?vue&type=script&setup=true&lang=js"

import "./Stage.vue?vue&type=style&index=0&id=57a082fc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a082fc"]])

export default __exports__